import { useEffect } from "react";
import "../../assets/css/footer.css";
import { useState } from "react";
import defaultLang, { englishLang } from "../../config";
import heart from '../../assets/img/footer/heart.svg';
import { Link } from "react-router-dom";

export default function FooterSection() {
  const [localStorageChange, setLocalStorageChange] = useState(JSON.parse(localStorage.getItem('lang')) || defaultLang);

  const textsFr = {
    accesrapide: 'Accès rapide',
    fournisseur: 'Fournisseurs',
    mention: 'Mentions légales'
  }

  const textsEn = {
    accesrapide: 'Quick access',
    fournisseur: 'Provider',
    mention: 'Legal notice'
  }

  return (
    <footer className="container-fluid">
      <div className="row">
        <div className="col-lg-6 col-md-12 col-sm-12 navigation">
          <ul>
            <li className="nav-item">
              <Link to="#">{localStorageChange.code === englishLang.code ? textsEn.accesrapide : textsFr.accesrapide}</Link>
            </li>
            <li className="nav-item">
              <Link to="https://baya.axian-group.com/oxalink/index.php" target="_blank">{localStorageChange.code === englishLang.code ? textsEn.fournisseur : textsFr.fournisseur}</Link>
            </li>
            <li className="nav-item">
              <Link to="https://www.axian-group.com/mentions-legales/" target="_blank">{localStorageChange.code === englishLang.code ? textsEn.mention : textsFr.mention}</Link>
            </li>
          </ul>
        </div>
        <div className="col-lg-6 col-md-12 col-sm-12 copyright">
          <p>Developed with <img src={heart} alt="heart" /> by AXIAN Group</p>

          <ul>
            <li>
              <Link to="https://www.facebook.com/axiangroup/" target="_blank">
                <i className="bi bi-facebook"></i>
              </Link>
            </li>
            <li>
              <Link to="https://www.linkedin.com/company/axian-group/mycompany/verification/?viewAsMember=true" target="_blank">
                <i className="bi bi-linkedin"></i>
              </Link>
            </li>
            <li>
              <Link to="https://twitter.com/AxianGroup/" target="_blank">
                {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-twitter-x" viewBox="0 0 16 16">
                  <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z" />
                </svg> */}
                <i className="bi bi-twitter-x"></i>
              </Link>
            </li>
            <li>
              <Link to="https://www.instagram.com/axiangroup/" target="_blank">
                <i className="bi bi-instagram"></i>
              </Link>
            </li>
            <li>
              <Link to="https://www.tiktok.com/@axiangroup" target="_blank">
                <i className="bi bi-tiktok"></i>
              </Link>
            </li>
            <li>
              <Link to="https://www.youtube.com/@axiangroup" target="_blank">
                <i className="bi bi-youtube"></i>
              </Link>
            </li>
            <li>
              <Link to="https://whatsapp.com/channel/0029VaPn7IFKGGGIAAHDlf3s" target="_blank">
                <i className="bi bi-whatsapp"></i>
              </Link>
            </li>
          </ul>

        </div>
      </div>
    </footer>
  );
}
